import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService  } from '@syncfusion/ej2-angular-grids';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ClienttemplateComponent } from './clienttemplate.component';
import { clienttemplateRoutingModule } from './clienttemplate.routing.module';
import { SignaturePadModule } from 'angular2-signaturepad';
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
  declarations: [
    ClienttemplateComponent
  ],
  imports: [
    NgSelectModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MyDatePickerModule,
    SignaturePadModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    clienttemplateRoutingModule

  ],
  exports:[ClienttemplateComponent],
  providers: [ColumnChooserService,PageService,SortService,FilterService, ResizeService,ClienttemplateComponent ],
})
export class clienttemplateModule { }
